var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":_vm.isLoading,"opacity":1.0},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('MainHeader',{on:{"signOut":_vm.signOut}}),_c('router-view'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }